import { jsx as _jsx } from "react/jsx-runtime";
import { DismissRegular, FilterFilled } from '@fluentui/react-icons';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
const FiltersDiscardButton = ({ hasNewChanges = false, handleDiscardFilters, handleShowFilters }) => {
    const { t } = useTranslation();
    return (_jsx(Button, { className: 'filter-discard-btn', variant: 'outlined', color: hasNewChanges ? 'error' : 'inherit', size: 'medium', startIcon: hasNewChanges ? _jsx(DismissRegular, { fontSize: 20 }) : _jsx(FilterFilled, { fontSize: 20 }), onClick: hasNewChanges ? handleDiscardFilters : handleShowFilters, children: hasNewChanges ? t('DiscardFilters') : t('Filter') }));
};
export default FiltersDiscardButton;
